/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_BroadcastInputs */

const th_video_broadcast = /** @type {(inputs: Video_BroadcastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ถ่ายทอดสด`)
};

const en_video_broadcast = /** @type {(inputs: Video_BroadcastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Broadcast`)
};

const ja_video_broadcast = /** @type {(inputs: Video_BroadcastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`配信`)
};

const zh_video_broadcast = /** @type {(inputs: Video_BroadcastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`直播`)
};

const es_video_broadcast = /** @type {(inputs: Video_BroadcastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retransmitir`)
};

const pt_video_broadcast = /** @type {(inputs: Video_BroadcastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transmitir`)
};

const id_video_broadcast = /** @type {(inputs: Video_BroadcastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siarkan`)
};

const fr_video_broadcast = /** @type {(inputs: Video_BroadcastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diffuser`)
};

const tl_video_broadcast = /** @type {(inputs: Video_BroadcastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Isahimpapawid`)
};

const vi_video_broadcast = /** @type {(inputs: Video_BroadcastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phát`)
};

const ko_video_broadcast = /** @type {(inputs: Video_BroadcastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`중계`)
};

const de_video_broadcast = /** @type {(inputs: Video_BroadcastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Übertragen`)
};

const ru_video_broadcast = /** @type {(inputs: Video_BroadcastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Транслировать`)
};

const tr_video_broadcast = /** @type {(inputs: Video_BroadcastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yayınla`)
};

const it_video_broadcast = /** @type {(inputs: Video_BroadcastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trasmetti`)
};

const pl_video_broadcast = /** @type {(inputs: Video_BroadcastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transmituj`)
};

const uk_video_broadcast = /** @type {(inputs: Video_BroadcastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Транслювати`)
};

const hi_video_broadcast = /** @type {(inputs: Video_BroadcastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रसारित करें`)
};

const ar_video_broadcast = /** @type {(inputs: Video_BroadcastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بث`)
};

const ms_video_broadcast = /** @type {(inputs: Video_BroadcastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siarkan`)
};

const bn_video_broadcast = /** @type {(inputs: Video_BroadcastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সম্প্রচার`)
};

const zh_tw2_video_broadcast = /** @type {(inputs: Video_BroadcastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`轉播`)
};

const zh_hk2_video_broadcast = /** @type {(inputs: Video_BroadcastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`轉播`)
};

const ur_video_broadcast = /** @type {(inputs: Video_BroadcastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نشر کریں`)
};

const fa_video_broadcast = /** @type {(inputs: Video_BroadcastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`پخش`)
};

const sw_video_broadcast = /** @type {(inputs: Video_BroadcastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rusha`)
};

const nl_video_broadcast = /** @type {(inputs: Video_BroadcastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uitzenden`)
};

/**
* | output |
* | --- |
* | "Broadcast" |
*
* @param {Video_BroadcastInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const video_broadcast = /** @type {((inputs?: Video_BroadcastInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_BroadcastInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_video_broadcast(inputs)
	if (locale === "ja") return ja_video_broadcast(inputs)
	if (locale === "zh") return zh_video_broadcast(inputs)
	if (locale === "es") return es_video_broadcast(inputs)
	if (locale === "pt") return pt_video_broadcast(inputs)
	if (locale === "id") return id_video_broadcast(inputs)
	if (locale === "fr") return fr_video_broadcast(inputs)
	if (locale === "tl") return tl_video_broadcast(inputs)
	if (locale === "vi") return vi_video_broadcast(inputs)
	if (locale === "ko") return ko_video_broadcast(inputs)
	if (locale === "de") return de_video_broadcast(inputs)
	if (locale === "ru") return ru_video_broadcast(inputs)
	if (locale === "tr") return tr_video_broadcast(inputs)
	if (locale === "it") return it_video_broadcast(inputs)
	if (locale === "pl") return pl_video_broadcast(inputs)
	if (locale === "uk") return uk_video_broadcast(inputs)
	if (locale === "hi") return hi_video_broadcast(inputs)
	if (locale === "ar") return ar_video_broadcast(inputs)
	if (locale === "ms") return ms_video_broadcast(inputs)
	if (locale === "bn") return bn_video_broadcast(inputs)
	if (locale === "zh-TW") return zh_tw2_video_broadcast(inputs)
	if (locale === "zh-HK") return zh_hk2_video_broadcast(inputs)
	if (locale === "ur") return ur_video_broadcast(inputs)
	if (locale === "fa") return fa_video_broadcast(inputs)
	if (locale === "sw") return sw_video_broadcast(inputs)
	if (locale === "nl") return nl_video_broadcast(inputs)
	return en_video_broadcast(inputs)
});